<script lang="ts" setup>

import type {MultiChoice, Option} from '@/ts/types/dto/interventions-dto';
import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';
import {computed} from 'vue';

const props = defineProps<{
  question: MultiChoice;
  answers: UuidDTO[];
}>();

const answer = computed<Option[]>(() =>
  props.answers
    .map((uuid) => props.question.options.find(opt => opt.id === uuid))
    .filter((opt): opt is Option => Boolean(opt)));
</script>

<template>
  <div>
    {{ answer.length ? `${answer[0].value}: ${answer[0].text}` : $t('no_user_input') }}
  </div>
</template>
<style lang="scss" scoped>

</style>
